<template>
  <div class="lbv-leak-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <div class="col-lg-12 leak-list-header">
            <span class="lbv-page-title">Removed Devices</span>
          </div>
          <div class="row secondary lbv-search">
            <form
              class="lbv-search-filter leak-list-form"
              @submit.prevent="search"
            >
              <div class="leaklistFilters w-100">
                <b-row class="d-flex align-items-center">
                  <b-col cols="2">
                    <b-form-group
                      label="Search Type"
                      label-for="search-type"
                    >
                      <select
                        id="search-type"
                        v-model="searchType"
                        class="form-control full-width"
                        accesskey="/"
                      >
                        <option value="last_name">
                          Surname
                        </option>
                        <option value="first_name">
                          First name
                        </option>
                        <option value="leakbot_id">
                          LeakBot ID
                        </option>
                        <option value="device_name">
                          SigFox ID
                        </option>
                      </select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group
                      label="Search"
                      label-for="search"
                    >
                      <input
                        id="search"
                        v-model="searchString"
                        type="text"
                        class="form-control w-100"
                        required
                      >
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Tenant"
                      label-for="select-tenants"
                    >
                      <b-form-select
                        id="select-tenants"
                        v-model="tenantSelection"
                        class="full-width"
                        @input="fetchLeakListData"
                      >
                        <option :value="null">
                          All Tenants
                        </option>
                        <option
                          v-for="tenant in tenants"
                          v-bind="$attrs"
                          :key="tenant.id"
                          :value="{ name: tenant.name }"
                          @option="$emit('option', $event.target.value)"
                        >
                          {{ tenant.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Rows"
                      label-for="rows-filter"
                    >
                      <b-form-select
                        id="rows-filter"
                        v-model="perPage"
                        :options="pageOptions"
                        @input="fetchLeakListData"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="3"
                    class="d-flex align-items-center"
                  >
                    <b-button
                      id="applyBtn"
                      variant="primary"
                      type="submit"
                      class="w-100 mr-3"
                    >
                      Apply
                    </b-button>
                    <b-button
                      type="submit"
                      variant="primary"
                      class="w-100"
                      @click.prevent="downloadReport"
                    >
                      <span class="download">Export CSV File</span>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </form>
          </div>
          <b-alert
            :show="errorMessage != ''"
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
          <b-table
            small
            responsive
            striped
            hover
            :items="deviceList"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template
              slot="leakbotId"
              slot-scope="data"
            >
              <!--<router-link :to="`deviceview/${data.value}`" class="deviceLink">{{data.value}}</router-link>-->
              <router-link
                :to="{ name: 'DeviceView', params: { deviceID: data.value }}"
                class="deviceLink"
              >
                {{ data.value }}
              </router-link>
            </template>
            <template
              slot="needHelp"
              slot-scope="data"
            >
              <strong v-if="data.item.needHelp === 'GetHelp'">{{ data.value }}</strong>
              <div v-else>
                {{ data.value }}
              </div>
            </template>
            <template
              slot="repairComplete"
              slot-scope="data"
            >
              <strong v-if="data.item.repairComplete === 'GetHelp'">{{ data.value }}</strong>
              <div v-else>
                {{ data.value }}
              </div>
            </template>
          </b-table>
          <b-button
            class="page prev"
            variant="primary"
            size="sm"
            :disabled="pageNumber === 1"
            @click.prevent="page"
          >
            Prev
          </b-button>

          <b-button
            class="page next"
            variant="primary"
            size="sm"
            :disabled="!hasNextPage"
            @click.prevent="page"
          >
            Next
          </b-button>
          <div class="current-page">
            Page: {{ pageNumber }}
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import removedDevicesMixin from '../mixins/removedDevicesMixin'

export default {
  name: 'RemovedDevices',
  mixins: [removedDevicesMixin]
}
</script>
<style media="screen">
  .lbv-leak-list .leaklistFilters .full-width {
    width: 100% !important;
  }

  .lbv-leak-list .leaklistFilters label {
    font-size: 0.8rem
  }

  .lbv-leak-list .leaklistFilters .push-down {
    margin-top: 1rem;
  }

</style>
